<template>
<div>
      <div class="aboutus column">
        <div id="banner">
             <h1>推动自动化变形监测行业发展</h1>
             <p>打造业内最强自动化变形监测解决方案平台</p>
        </div>   
        <div class="intro_box">
            <h2>公司简介</h2>
            <div class="intro_company row">
            <img src="../assets/aboutus/2.jpg" alt="">
            <div class="intro_text">
                <h3>公司介绍</h3>
                <p>北京奥腾岩石科技有限公司（简称“岩石科技”）成立于2011年，是一家专业从事地理信息装备、安全<br>监测系统集成及技术应用的高科技企业，获得由市科委、市财政局、市国税局、市地税局颁发的“高新技<br>术企业”证书，以及中关村科技管理委员会认定的“中关村高新企业”认证，同时也是北京市经济和信息<br>化委员会认定的“双软认证”企业，公司还获得了由北京市规划委员会颁发的乙级测绘资质证书、北京经<br>济开发区科技局颁发的“新区企业研发机构”证书、国家知识产权局颁发的实用新型专利证书：”一体化<br>智能监测终端及系统“、”一种导航自动驾驶系统”。总部位于北京经济技术开发区思格玛高新技术园区<br>，并在北京、武汉两地设有研发机构。公司技术力量雄厚，汇聚了一批经验丰富的管理人员和优秀的技术<br>研发团队，拥有员工100余名，30多家渠道合作伙伴，他们构成了覆盖全国的销售及服务网络，为客户提<br>供更具竞争力的产品及更优质的服务</p>
            </div>

        </div>
        </div>

        <div class="brand_box">
             <h3>目前公司拥有以下几大产品品牌</h3>
            <div class="brand_center row">
                <div class="brand_item columns" v-for="item in brandlists" :key="item.title">
                    <img :src="item.img" alt="">
                    <div class="b_line"></div>
                    <h6>{{item.title}}</h6>
                    <p>{{item.word}}</p>
                </div>             
          </div>
        </div>


        <div class="roc_banner column">
            <img src="../assets/aboutus/15.png" alt="">
            <p>RocMoS系统是北京奥腾岩石科技有限公司自主研发的一套自动化变形监测系统</p>
            <p>集成硬件与软件，经过行业多年打磨，功能模块齐全，系统安全稳定，已经逐渐成长为行业标杆</p>
        </div>

        <div class="honnur_box">
            <h2>荣誉资质</h2>
            <div class="honnur_center rows">
             <img src="../assets/aboutus/8.jpg" alt="">  
              <img src="../assets/aboutus/9.jpg" alt="">    
               <img src="../assets/aboutus/10.jpg" alt="">   
            </div>
            <div class="center_b row">
             <img src="../assets/aboutus/11.jpg" alt="">  
              <img src="../assets/aboutus/12.jpg" alt="">    
               <img src="../assets/aboutus/13.jpg" alt="">  
                <img src="../assets/aboutus/14.jpg" alt="">    
            </div>
        </div>

        <div class="location_box">
            <h2>地理位置</h2>
            <div class="loc_center">
            <!-- <vue-googlemap :center="center" :zoom="zoom">
               <vue-googlemap-marker :position="center" ref='marker' @click='open(o)'></vue-googlemap-marker>     
                     <vue-googlemap-infoWindow :position='center'
                                    content='水电费电话费回合肥'
                                    :events="events"
                                    ref='window'></vue-googlemap-infoWindow>
            </vue-googlemap>     -->



            <div id="map_canvas" style="height: 100%; width: 100%"></div>




            </div>
        </div>
   
    </div>
    <foot></foot>

</div>
  
</template>
<style>
.aboutus #banner {
  width: 100%;
  height: 3.5rem;
  background-image: url("../assets/aboutus/1.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 2;
}
.aboutus #banner h1 {
  font-size: 0.44rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  padding-left: 3.6rem;
  padding-top: 1.24rem;
}
.aboutus #banner p {
  font-size: 0.2rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  padding-left: 3.6rem;
  padding-top: 0.26rem;
}
.aboutus h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  text-align: center;
  margin-top: 0.56rem;
  padding-bottom: 0.35rem;
}
.intro_box {
  width: 100%;
  height: 5.28rem;
  background: rgba(245, 248, 255, 1);
}
.intro_company {
  width: 12rem;
  margin-top: 0.35rem;
  margin: 0 auto;
}
.intro_company img {
  width: 4.8rem;
  height: 3.06rem;
  margin-top: 0.17rem;
  z-index: 22;
  margin-right: -0.81rem;
}
.intro_company .intro_text {
  width: 8.01rem;
  height: 3.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.02rem;
  z-index: 1;
  padding-left: 1.18rem;
}
.intro_company .intro_text h3 {
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-top: 0.42rem;
  padding-bottom: 0.21rem;
}
.intro_company .intro_text p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  line-height: 0.2rem;
}
.brand_box {
  width: 100%;
  height: 4.29rem;
  background: rgba(247, 247, 247, 1);
}
.brand_box h3 {
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  text-align: center;
  padding-top: 0.56rem;
  padding-bottom: 0.46rem;
}
.brand_box .brand_center {
  width: 12rem;
  height: 2.6rem;
  justify-content: space-between;
  margin: 0 auto;
}
.brand_box .brand_center .b_line {
  width: 0.24rem;
  height: 0.02rem;
  background: rgba(67, 148, 208, 1);
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}
.brand_box .brand_center .brand_item {
  width: 2.84rem;
  height: 2.6rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(220, 220, 220, 1);
}
.brand_box .brand_center h6 {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-bottom: 0.18rem;
}
.brand_box .brand_center p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.roc_banner {
  width: 100%;
  height: 4.2rem;
  background-image: url("../assets/aboutus/7.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  align-items: center;
}
.roc_banner img {
  width: 1.93rem;
  height: 0.35rem;
  margin-top: 1.31rem;
  margin-bottom: 0.6rem;
}
.roc_banner p {
  font-size: 0.18rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  padding-bottom: 0.25rem;
}
.honnur_box {
  width: 100%;
  height: 6.09rem;
  background: rgba(245, 248, 255, 1);
}
.honnur_center {
  width: 12rem;
  margin-top: 0.46rem;
  margin: 0 auto;
}

.center_b {
  margin: 0 auto;
  width: 12rem;
  justify-content: space-between;
  margin-top: 0.26rem;
}
.location_box {
  width: 100%;
  height: 6.02rem;
  background: rgba(255, 255, 255, 1);
}
.loc_center {
  width: 12.2rem;
  height: 4.2rem;
  margin: 0 auto;
}
#allmap {
  width: 100%;
  height: 100%;
  display: block;
}
/* 百度地图信息框修改 */
/* .gm-style .gm-style-iw-t::after {
  background: transparent;
  box-shadow: 0 0 0 0;
}
.gm-style .gm-style-iw-c{
  background-color: transparent;
  box-shadow: 0 0 0 0;
  height: 200px;
  border-left: 1px solid #FF0000;
  border-radius: 0 !important;
  padding: 0 !important;
}
.gm-style-iw-d{
  overflow: hidden !important;
  background-color: #FF0000
  } */
</style>

<script>
import footer from "../common/footer";

export default {
  data() {
    return {
      brandlists: [
        {
          img: require("../assets/aboutus/3.jpg"),
          title: "岩蚁",
          word: "高精度测量与安全监测"
        },
        {
          img: require("../assets/aboutus/4.jpg"),
          title: "岩蛙",
          word: "精准农业以及精密机械控制系统"
        },
        {
          img: require("../assets/aboutus/5.jpg"),
          title: "岩鹰",
          word: "无人机航测和多功能飞行器等系统集成"
        },
        {
          img: require("../assets/aboutus/6.jpg"),
          title: "岩峰",
          word: "三维激光扫描及BIM应用以及移动测绘等"
        }
      ],
      center: { lat: 30.47445377586607, lng: 114.31428788598123 },
      zoom: 15,
      position: { lat: 30.47445377586607, lng: 114.31428788598123 },
      content: "北京奥腾岩石科技",
      events: {
        closeclick() {
          console.log("click!");
        }
      }
    };
  },
  components: {
    foot: footer
  },
  methods: {
    //  地图实例
    mapBuild() {
      //创建地图实例，zoom是缩放比例
      let map = new google.maps.Map(document.getElementById("map_canvas"), {
        zoom: 15,
        center: this.center,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        gestureHandling: "greedy"
      });
      //这里因为需要很多标记，所以遍历了this.markers（后端给的数据）来循环创建标记

      let marker = new google.maps.Marker({
        position: { lat: 30.47445377586607, lng: 114.31428788598123 },
        title: "北京奥腾岩石科技有限公司",
        draggable: true,
        animation: google.maps.Animation.DROP
      },
      {
        position: { lat: 30.48, lng: 114.32 },
        title: "有限公司",
        draggable: true,
        animation: google.maps.Animation.DROP
      });

      //自定义信息窗口
      let iw = new google.maps.InfoWindow({
        // pixelOffset:{width:175,
        //              height:40},
        content: `<div style="padding:5px"><p><b>公司</b>：北京奥腾岩石科技有限公司</p>
        <p><b>地址</b>：武汉市洪山区野芷湖西路16号武汉创意天地6号楼4层</p>
          <p><b>电话</b>：010-58080000</p>
          </div>`,
         
      });

      // var cityCircle = new google.maps.Circle({
      //   strokeColor: "#FF0000",
      //   strokeOpacity: 0.35,
      //   strokeWeight: 2,
      //   fillColor: "#FF0000",
      //   fillOpacity: 0.35,
      //   map: map,
      //   center: { lat: 30.47445377586607, lng: 114.31428788598123 },
      //   radius: 100,
      // });

      // 标记
      marker.setMap(map);

      //点击信息窗口显示
      marker.addListener("click", function() {
        iw.open(map, marker);
      });
    }
  },
  mounted() {
    if (google) {
      //谷歌地图的方法

      this.mapBuild(); //初始化实例之后调用
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/homepages/aboutus.vue